// src/app/core/error/error-logger.service.ts
import { Injectable, isDevMode } from '@angular/core';

  const seen = new WeakSet<object>();

@Injectable({ providedIn: 'root' })
export class ErrorLoggerService {
  private context: Record<string, unknown> = {};
  attachContext(ctx: Record<string, unknown>) {
    this.context = { ...this.context, ...ctx };
  }

 log(error: unknown, context: any = {}) {
    if (typeof error === 'object' && error !== null) {
      if (seen.has(error as object)) return; // dedupe
      seen.add(error as object);
    }
    if (isDevMode()) {
      console.warn('[ErrorLogger]', { when: new Date().toISOString(), context, error });
    }
    // TODO: send to backend here in production if needed
  }

  private normalize(e: unknown) {
    if (e instanceof Error) return { name: e.name, message: e.message, stack: e.stack };
    if (typeof e === 'object') return e;
    return { message: String(e) };
  }
}
